// extracted by mini-css-extract-plugin
export default {"addSupplierSection":"style_addSupplierSection__Rr42u","actionsSection":"style_actionsSection__GYtXo","formSection":"style_formSection__jt+Ta"};